import _ from 'lodash';
import React, { useEffect, useState } from 'react';

export default function HeaderRowTemplate({ context, msgValidate }) {
  const [className, setClassName] = useState('wj-bg-white');

  useEffect(
    () => {
      let className = 'wj-bg-white';
      const index = _.findIndex(msgValidate, ['work_id', context.item.id]);
      if (index > -1) {
        className = 'wj-bg-red';
      } else if (!_.isEmpty(context.item.is_data_changed)) {
        className = 'wj-bg-yellow';
      }
      setClassName(className);
    },
    [msgValidate, context.item.is_data_changed]
  );

  const getIndex = () => {
    const index = context.row.dataIndex;
    return index > -1 ? `000${index + 1}`.slice(-4) : '';
  };
  return (
    <div className={[className, 'wj-wrapper-content'].join(' ')}>
      <span className='row-index' key={context.item.id}>
        {getIndex()}
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/HeaderRowTemplate.jsx